<template>
  <div>
    <div class="title">Basic information</div>

    <table border="1" cellspacing="0">
      <tr>
        <td class="tableLeft">GeneId</td>
        <td>{{tabData.geneId}}</td>
      </tr>
      <tr>
        <td class="tableLeftOdd">Gene type</td>
        <td>{{tabData.geneType}}</td>
      </tr>
      <tr>
        <td class="tableLeft">Locus</td>
        <td>{{tabData.locus}}</td>
      </tr>
      <tr>
        <td class="tableLeftOdd">Length</td>
        <td>{{tabData.length}}</td>
      </tr>
      <tr>
        <td class="tableLeft">Species</td>
        <td>{{tabData.species}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabData:""
    };
  },
  props: ["id"],
  created() {
     let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    //console.log(this.id);
    this.getBasic(this.id);
  },
  methods: {
    getBasic(id) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/gene/basic/" + id,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          that.tabData=response.data.geneOtherInfo;
        })
        .catch(function (error) {
          that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.title {
  color: seagreen;
}
table,
tr,
td {
  padding: 0;
  margin: 0;
}
table {
  margin-top: 50px;
  width: 910px;
  border-color: #ccc;
  background-color: #fff;
}
table tr {
  line-height: 50px;
}
table td {
  text-align: center;
  line-height: 40px;
  border-color: #ccc;
  line-height: 40px;
}
.tableLeft {
  background-color: rgb(128, 207, 158);
}
.tableLeftOdd {
  background-color: rgb(208, 216, 211);
}
</style>>